import LoanPaymentInformationService from "@/services/v2/nwapp/loanPaymentInformation.service";

export const loanPaymentInformationApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getLoanPaymentInformation({ commit }, { fileDataId, loanPaymentId }) {
      return LoanPaymentInformationService.getLoanPaymentInformation(
        fileDataId,
        loanPaymentId
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.getLoanPaymentInformation - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.getLoanPaymentInformation - error"
          );
          return Promise.reject(error);
        }
      );
    },
    getLoanPaymentInformationEntry({ commit }, { fileDataId, loanPaymentId }) {
      return LoanPaymentInformationService.getLoanPaymentInformationEntry(
        fileDataId,
        loanPaymentId
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.getLoanPaymentInformationEntry - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.getLoanPaymentInformationEntry - error"
          );
          return Promise.reject(error);
        }
      );
    },
    createLoanPaymentInformation(
      { commit },
      { fileDataId, loanPaymentId, entry }
    ) {
      return LoanPaymentInformationService.createLoanPaymentInformation(
        fileDataId,
        loanPaymentId,
        entry
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.createLoanPaymentInformation - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.createLoanPaymentInformation - error"
          );
          return Promise.reject(error);
        }
      );
    },
    deleteLoanPaymentInformation(
      { commit },
      { fileDataId, loanPaymentInformationId }
    ) {
      return LoanPaymentInformationService.deleteLoanPaymentInformation(
        fileDataId,
        loanPaymentInformationId
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.deleteLoanPaymentInformation - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentInformationService.deleteLoanPaymentInformation - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
